import { MessageBox } from 'element-ui'
import {apiIndexHelp, apiProductList, apiNewsad} from '@/api/api'
import store from '@/store/index'

const common = {
    state: {
        helpList: '',
        goodsList: [],
        noticeList: []
    },


    actions: {
        getNewsAd({ commit, state }){
            apiNewsad({page: 1, limit: 6}).then(res => {
                if(res.code === 1){
                    state.noticeList = res.data.data;
                }
            })
        },
        getProductLst({ commit, state }){
            apiProductList({page: 1, limit: 10, sort: 'time_desc'}).then(res => {
                if(res.code === 1){
                    state.goodsList = res.data.rows;
                }
            })
        },
        getIndexHelp({ commit, state }){
            apiIndexHelp().then(res => {
                state.helpList = res.data;
            })
        },
    }
}

export default common



// WEBPACK FOOTER //
// ./src/store/modules/common.js